import React from 'react';

const NotFound: React.FC = () => {

  return (
    <>
      <div className="errorBox  h-[211px] w-[100%] border-[10px] border-[#D70D0D]  ">
        <p className="errorMessage flex h-[100%] items-center justify-center text-[41px] font-semibold leading-[57px]">
          Page not found
        </p>
      </div>
      <div className="errorInformation mt-[27px] h-[180px] w-[308px] sm:w-[100%]">
        <p className="leading[30.17px] text-[24px] font-bold">
          If you typed the web address, check it is correct.
        </p>
        <p className="leading[30.17px] mt-[27px] text-[24px] font-bold">
          If you pasted the web address, check you copied the entire address.
        </p>
      </div>
    </>
  );
}

export default NotFound;
